import {SocketController} from './SocketController'
import {SocketActionController} from './SocketActionController'
import {SocketLobbyListen} from './SocketLobbyListen'
import {SocketGameListen} from './SocketGameListen'
import {SocketMatchmakingListen} from './SocketMatchmakingListen'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {SocketMonitor} from './SocketMonitor'

export class Socket {
    readonly controller: SocketController
    readonly actionController: SocketActionController

    readonly lobbyListener: SocketLobbyListen
    readonly gameListener: SocketGameListen
    readonly matchmakingListener: SocketMatchmakingListen

    readonly monitor: SocketMonitor

    constructor(socketActionController: SocketActionController) {
        this.actionController = socketActionController
        this.controller = new SocketController(UIAPIEndpoints.socketServerWSS())

        this.gameListener = new SocketGameListen(this.controller, this.actionController)
        this.lobbyListener = new SocketLobbyListen(this.controller, this.actionController)
        this.matchmakingListener = new SocketMatchmakingListen(this.controller, this.actionController)
        this.monitor = new SocketMonitor(this.controller)
    }

    connect() {
        this.controller.enableConnect()
    }
}
